import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import { IntlProviderWrapper } from "./utils/IntlContextProvider";
import { ThemeProvider } from "./context/ThemeContext";
import { PaymentFormProvider } from "./context/PaymentFormContext";
import CONSTANTS from './utils/constants';

import './custom.scss';
import App from './App';

async function initApp() {
  let scriptSrc: string | undefined;
  let scriptIntegrity: string | undefined;

  if (window.location.origin === CONSTANTS.PROD_URL) {
    scriptSrc = 'https://sdk.tokenization.secure.payone.com/1.7.0/hosted-tokenization-sdk.js';
    scriptIntegrity = 'sha384-En0FTt1/y/oAtSiKcVajUNbL3xKFS6znYv+TGUO6wtMrD8d//NlUJRCVA7PT44Ua';
  } else {
    try {
      const res = await fetch('/config.json');

      if (!res.ok) {
        throw new Error(`config.json failed (${res.status})`);
      }

      const config: AppConfig = await res.json();
      window.appConfig = config;

      scriptSrc = config.creditCardSdkLink;
      scriptIntegrity = config.sdkIntegrityHash;
    } catch (err) {
      console.warn('Failed to load config.json, continuing without SDK', err);
    }
  }

  if (scriptSrc && !document.getElementById('hosted-tokenization-sdk')) {
    const script = document.createElement('script');
    script.id = 'hosted-tokenization-sdk';
    script.src = scriptSrc;

    if (scriptIntegrity?.startsWith('sha')) {
      script.integrity = scriptIntegrity;
      script.crossOrigin = 'anonymous';
    }

    document.head.appendChild(script);

    await new Promise<void>((resolve) => {
      script.onload = () => resolve();
      script.onerror = (e) => {
        console.error('SDK script failed to load', e);
        resolve();
      };
    });
  } else if (!scriptSrc) {
    console.warn('SDK source could not be resolved');
  }

  try {
    const rootElement = document.getElementById('root');

    if (!rootElement) {
      throw new Error('Root element not found');
    }

    const root = ReactDOM.createRoot(rootElement);

    root.render(
      <StrictMode>
        <BrowserRouter>
          <IntlProviderWrapper>
            <ThemeProvider>
              <PaymentFormProvider>
                <App />
              </PaymentFormProvider>
            </ThemeProvider>
          </IntlProviderWrapper>
        </BrowserRouter>
      </StrictMode>
    );
  } catch (err) {
    console.error('Failed to initialize app UI:', err);
  }
}


initApp();
